import {Location} from '@angular/common';
import {AfterViewInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ACCESS_TOKEN} from '../../../shared/consts';
import {tokenNotExpired} from '../../../shared/utilities/token-not-expired';
import {Subscription} from 'rxjs';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
/* tslint:disable */
@Component({ selector: 'storever-privacy-policy', templateUrl: './privacy-policy.component.html', styleUrls: ['./privacy-policy.component.scss'] })
export class PrivacyPolicyComponent implements OnInit, OnDestroy, AfterViewInit {

  lang: string;
  currentLang: string;
  fragment: string;
  param: any;
  consentForm = false;
  private sub$: Subscription;
  private subscriptions = [];

  constructor(private _location: Location,
              private route: ActivatedRoute,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              private _router: Router,
              private cdr: ChangeDetectorRef) {
    this.currentLang = this.locale.language;
    this.sub$ = this.route.fragment.subscribe(fragment => { this.fragment = fragment; });
    this.subscriptions.push(this.sub$);
  }

  ngOnInit(): void {
    this.param = window.location.search;
    this.param = this.param.split('&');
    let j;
    for (j = 0; j < this.param.length; j++) {
      if (this.param[j].toLowerCase().indexOf('consent-form') !== -1) {
        this.consentForm = true;
      }
    }
    if (!tokenNotExpired(ACCESS_TOKEN)) {
      if (!this.consentForm) {
        this._router.navigateByUrl('/login');
      }
    }
  }
  deCode(q): any { return unescape(this.param[q].split('=')[1].replace(/\s/g, '')); }

  ngOnDestroy(): void {
   // this.locale.setCurrentLanguage(this.currentLang)
      if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  ngAfterViewInit(): void {
    try {
      document.querySelector('#' + this.fragment).scrollIntoView();
    } catch (e) {
    }
  }

  setCurrentLanguage(lang: string): void {
   // this.locale.setCurrentLanguage(lang)
  }

  goBack(): void { this._location.back(); }
}
